import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DevFilePathBadge } from './DevFilePathBadge';
import { adminLoginPath, adminPath } from '../../lib/adminPaths';

// ルートパスとファイルパスのマッピング
const ROUTE_TO_FILE_MAP: Record<string, string> = {
  '/': 'client/src/pages/LandingPage.tsx',
  '/login': 'client/src/pages/LoginPage.tsx',
  '/register': 'client/src/pages/RegisterPage.tsx',
  '/maintenance': 'client/src/pages/MaintenancePage.tsx',
  '/auth/password-reset': 'client/src/components/user/PasswordResetPage.tsx',
  '/reset-password': 'client/src/components/user/PasswordResetPage.tsx',
  '/industry-guides': 'client/src/pages/IndustryGuidesPage.tsx',
  '/industry-guides/:industryCode': 'client/src/pages/IndustryGuideDetailPage.tsx',
  '/help': 'client/src/pages/HelpPage.tsx',
  '/help/:articleId': 'client/src/pages/HelpArticlePage.tsx',
  '/demo-accounts': 'client/src/pages/DemoAccountsPage.tsx',
  '/service/plans': 'client/src/pages/public/ServicePlansPage.tsx',
  '/service/features': 'client/src/pages/public/ServiceDetailPage.tsx',
  '/contact': 'client/src/pages/public/ContactPage.tsx',
  '/logo-proposals': 'client/src/pages/LogoProposalPage.tsx',
  '/legal/terms-privacy': 'client/src/pages/public/TermsPrivacyPage.tsx',
  '/legal/specified-commercial-transactions': 'client/src/pages/public/SpecifiedCommercialTransactionsPage.tsx',
  '/auth/setup': 'client/src/pages/UserSetupPage.tsx',
  '/app': 'client/src/pages/DashboardPage.tsx',
  '/app/dashboard': 'client/src/pages/DashboardPage.tsx',
  '/app/announcements': 'client/src/pages/AnnouncementsPage.tsx',
  '/app/locations': 'client/src/pages/LocationsPageWithAPI.tsx',
  '/app/branches': 'client/src/pages/settings/BranchManagementPage.tsx',
  '/app/equipments': 'client/src/pages/EquipmentsPage.tsx',
  '/app/equipments/:id': 'client/src/pages/EquipmentDetailPage.tsx',
  '/app/deterioration': 'client/src/pages/DeteriorationPageRouter.tsx',
  '/app/deterioration/:id': 'client/src/pages/DeteriorationDetailPage.tsx',
  '/app/maintenance': 'client/src/pages/Maintenance/Calendar.tsx',
  '/app/maintenance/recurring-settings': 'client/src/pages/Maintenance/RecurringSettings.tsx',
  '/app/maintenance/:id': 'client/src/pages/ScheduleDetailPage.tsx',
  '/app/schedule/:id': 'client/src/pages/ScheduleDetailPage.tsx',
  '/app/my-tasks': 'client/src/pages/MyTasksPage.tsx',
  '/app/work-order-templates': 'client/src/pages/WorkOrderTemplates/WorkOrderTemplatesPage.tsx',
  '/app/work-order-templates/:id': 'client/src/pages/WorkOrderTemplates/WorkOrderTemplateDetailPage.tsx',
  '/app/work-history': 'client/src/pages/WorkHistory/index.tsx',
  '/app/work-history/:id': 'client/src/pages/WorkHistory/Detail.tsx',
  '/app/emergency-works': 'client/src/pages/EmergencyWorkPage.tsx',
  '/app/emergency-works/:id': 'client/src/pages/EmergencyWorkDetailPage.tsx',
  '/app/import': 'client/src/pages/ImportPage.tsx',
  '/app/export': 'client/src/pages/ExportPage.tsx',
  '/app/import-export': 'client/src/pages/ImportExportPage.tsx',
  '/app/parts': 'client/src/pages/PartsPage.tsx',
  '/app/parts/:id': 'client/src/pages/PartDetailPage.tsx',
  '/app/suppliers': 'client/src/pages/SuppliersPage.tsx',
  '/app/suppliers/:id': 'client/src/pages/SupplierDetailPage.tsx',
  '/app/stock-dashboard': 'client/src/pages/StockDashboardPage.tsx',
  '/app/purchase-orders': 'client/src/pages/PurchaseOrdersPage.tsx',
  '/app/purchase-orders/category-orders': 'client/src/pages/PurchaseOrderCategoryOrdersPage.tsx',
  '/app/purchase-orders/category-orders/:categoryId': 'client/src/pages/PurchaseOrderCategoryOrdersPage.tsx',
  '/app/purchase-orders/create': 'client/src/pages/CreatePurchaseOrderPage.tsx',
  '/app/purchase-orders/:id/pdf': 'client/src/pages/PurchaseOrderPdfOutputPage.tsx',
  '/app/purchase-orders/:id': 'client/src/pages/PurchaseOrderDetailPage.tsx',
  '/print/purchase-orders/:id': 'client/src/pages/PurchaseOrderPrintPage.tsx',
  '/app/parts-analytics': 'client/src/pages/PartsAnalyticsPage.tsx',
  '/app/part-consumption-logs': 'client/src/pages/PartConsumptionLogsPage.tsx',
  '/app/documents': 'client/src/pages/DocumentsPage.tsx',
  '/app/documents/official-inspections': 'client/src/pages/OfficialInspectionDocumentsPage.tsx',
  '/app/documents/:id': 'client/src/pages/DocumentDetailPage.tsx',
  '/app/notifications': 'client/src/pages/NotificationsPage.tsx',
  '/app/profile': 'client/src/components/user/ProfileManagement.tsx',
  '/app/profile/notifications': 'client/src/pages/settings/NotificationSettingsPage.tsx',
  '/app/settings': 'client/src/pages/settings/SettingsDashboardPage.tsx',
  '/app/settings/dashboard': 'client/src/pages/settings/SettingsDashboardPage.tsx',
  '/app/settings/company': 'client/src/pages/settings/CompanyInfoPage.tsx',
  '/app/settings/branches': 'client/src/pages/settings/BranchManagementPage.tsx',
  '/app/settings/advanced': 'client/src/pages/settings/AdvancedSettingsPage.tsx',
  '/app/settings/system-config': 'client/src/pages/settings/SystemConfigPage.tsx',
  '/app/settings/storage': 'client/src/pages/StorageManagement.tsx',
  '/app/settings/users': 'client/src/pages/UserManagementPage.tsx',
  '/app/settings/subscription': 'client/src/pages/settings/SubscriptionSettingsPage.tsx',
  '/app/settings/import': 'client/src/pages/ImportPage.tsx',
  '/app/settings/export': 'client/src/pages/ExportPage.tsx',
  '/app/settings/withdraw': 'client/src/pages/settings/WithdrawPage.tsx',
  '/app/categories': 'client/src/pages/settings/CategoriesPage.tsx',
  '/app/qr-labels': 'client/src/pages/QrLabelPrintPage.tsx',
  '/app/subscription': 'client/src/pages/settings/SubscriptionSettingsPage.tsx',
  '/app/subscription/bank-transfer/confirmation': 'client/src/pages/subscription/BankTransferConfirmationPage.tsx',
  '/app/subscription/addon': 'client/src/pages/subscription/AddonPurchasePage.tsx',
  '/app/user-management': 'client/src/pages/UserManagementPage.tsx',
  '/shared-app/dashboard': 'client/src/pages/DashboardPage.tsx',
  '/shared-app/maintenance': 'client/src/pages/Maintenance/Calendar.tsx',
  '/shared-app/maintenance/:id': 'client/src/pages/ScheduleDetailPage.tsx',
  '/shared-app/work-history': 'client/src/pages/WorkHistory/index.tsx',
  '/shared-app/work-history/:id': 'client/src/pages/WorkHistory/Detail.tsx',
  '/shared-app/emergency-works': 'client/src/pages/EmergencyWorkPage.tsx',
  '/shared-app/emergency-works/:id': 'client/src/pages/EmergencyWorkDetailPage.tsx',
  '/shared-app/my-tasks': 'client/src/pages/MyTasksPage.tsx',
  '/agency/login': 'client/src/pages/agency/AgencyLoginPage.tsx',
  '/agency/setup': 'client/src/pages/agency/AgencySetupPage.tsx',
  '/agency/dashboard': 'client/src/pages/agency/AgencyDashboardPage.tsx',
  '/agency/coupons': 'client/src/pages/agency/AgencyCouponsPage.tsx',
  '/agency/commissions': 'client/src/pages/agency/AgencyCommissionsPage.tsx',
  '/agency/profile': 'client/src/pages/agency/AgencyProfilePage.tsx',
  '/partner/login': 'client/src/pages/partner/PartnerLoginPage.tsx',
  '/partner/setup': 'client/src/pages/partner/PartnerSetupPage.tsx',
  '/partner/dashboard': 'client/src/pages/partner/PartnerDashboardPage.tsx',
  '/partner/companies': 'client/src/pages/partner/PartnerCompaniesPage.tsx',
  '/partner/companies/new': 'client/src/pages/partner/PartnerCompanyCreatePage.tsx',
  '/partner/companies/:companyId': 'client/src/pages/partner/PartnerCompanyDetailPage.tsx',
  '/partner/requests': 'client/src/pages/partner/PartnerRequestsPage.tsx',
  '/partner/users': 'client/src/pages/partner/PartnerUsersPage.tsx',
  [adminLoginPath]: 'client/src/pages/admin/AdminLoginPage.tsx',
  [adminPath('dashboard')]: 'client/src/pages/admin/AdminDashboard.tsx',
  [adminPath('companies')]: 'client/src/pages/admin/companies/CompanyListPage.tsx',
  [adminPath('companies/:companyId')]: 'client/src/pages/admin/companies/CompanyDetailPage.tsx',
  [adminPath('subscriptions')]: 'client/src/pages/admin/subscriptions/SubscriptionListPage.tsx',
  [adminPath('subscriptions/bank-transfers')]: 'client/src/pages/admin/subscriptions/BankTransferManagementPage.tsx',
  [adminPath('subscriptions/plan-master')]: 'client/src/pages/admin/subscriptions/PlanMasterPage.tsx',
  [adminPath('subscriptions/coupons')]: 'client/src/pages/admin/subscriptions/CouponManagementPage.tsx',
  [adminPath('agencies')]: 'client/src/pages/admin/agencies/AgencyListPage.tsx',
  [adminPath('agencies/:id')]: 'client/src/pages/admin/agencies/AgencyDetailPage.tsx',
  [adminPath('agencies/commissions')]: 'client/src/pages/admin/agencies/AgencyCommissionManagementPage.tsx',
  [adminPath('partners')]: 'client/src/pages/admin/partners/PartnerListPage.tsx',
  [adminPath('partners/:id')]: 'client/src/pages/admin/partners/PartnerDetailPage.tsx',
  [adminPath('announcements')]: 'client/src/pages/admin/notifications/AnnouncementListPage.tsx',
  [adminPath('users')]: 'client/src/pages/admin/users/UserListPage.tsx',
  [adminPath('users/:id')]: 'client/src/pages/admin/users/UserDetailPage.tsx',
  [adminPath('settings/access-templates')]: 'client/src/pages/admin/settings/AccessControlTemplatesPage.tsx',
  [adminPath('settings/maintenance')]: 'client/src/pages/admin/settings/MaintenanceModePage.tsx',
  [adminPath('admin-users')]: 'client/src/pages/admin/auth/AdminUserManagementPage.tsx',
  [adminPath('audit-log')]: 'client/src/pages/admin/auth/AuditLogViewerPage.tsx',
  [adminPath('dev-tools')]: 'client/src/pages/admin/DevToolsPage.tsx',
  [adminPath('user-activity')]: 'client/src/pages/admin/UserActivityPage.tsx',
};

/**
 * 開発環境で現在のルートに対応するファイルパスを表示
 */
export function DevRouteInfo(): JSX.Element | null {
  const location = useLocation();
  const [filePath, setFilePath] = useState<string>('');

  useEffect(() => {
    // 本番環境では何もしない
    if (import.meta.env.PROD) {
      return;
    }

    // 現在のパスから対応するファイルパスを検索
    let matchedPath = '';

    // 完全一致を試す
    if (ROUTE_TO_FILE_MAP[location.pathname]) {
      matchedPath = ROUTE_TO_FILE_MAP[location.pathname];
    } else {
      // パラメータ付きルートとマッチングを試す
      for (const [routePattern, file] of Object.entries(ROUTE_TO_FILE_MAP)) {
        // :id などのパラメータを正規表現に変換
        const regex = new RegExp(
          '^' + routePattern.replace(/:[^/]+/g, '[^/]+') + '$'
        );
        if (regex.test(location.pathname)) {
          matchedPath = file;
          break;
        }
      }
    }

    if (matchedPath) {
      setFilePath(matchedPath);
    } else {
      // マッチしない場合はパスそのものを表示
      setFilePath(`Unknown route: ${location.pathname}`);
    }
  }, [location.pathname]);

  if (!filePath) {
    return null;
  }

  return <DevFilePathBadge filePath={filePath} />;
}
